import React, { useContext } from 'react'
import { Table, Col, Input, Button, Row, Card, Popover, Divider, Popconfirm } from 'antd'
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined'
import MoreOutlined from '@ant-design/icons/lib/icons/MoreOutlined'
import { Context, useStore } from '../../../../context'

const { Search } = Input

function DiscountTable(props) {
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)

  const columns = [
    {
      align: 'left',
      title: 'Nivel de descuento',
      dataIndex: 'discount_level', // Field that is goint to be rendered
      key: 'discount_level',
      render: text => <span>{text}</span>,
    },
    {
      align: 'left',
      title: 'Nombre de empresa',
      dataIndex: 'company_name', // Field that is goint to be rendered
      key: 'company_name',
      render: text => <span>{text}</span>,
    },
    {
      title: '',
      dataIndex: 'id', // Field that is goint to be rendered
      key: 'id',
      render: (row, data) => (
        <span>
          {
            <Popover
              placement="left"
              style={{ zIndex: 'auto' }}
              content={
                <div>
                  {hasPermissions([79]) && (
                    <span className={'user-options-items'} onClick={() => handlerEditRow(data)}>
                      Editar
                    </span>
                  )}
                  {hasPermissions([79]) && hasPermissions([80]) && <Divider className={'divider-enterprise-margins'} type={'horizontal'} />}
                  {hasPermissions([80]) && (
                    <Popconfirm
                      title="¿Estás seguro de eliminar el elemento selccionado?"
                      onConfirm={() => handlerDeleteRow(data)}
                      okText="Sí"
                      cancelText="No"
                    >
                      <span className={'user-options-items'}>Eliminar</span>
                    </Popconfirm>
                  )}
                </div>
              }
              trigger="click"
            >
              {(hasPermissions([79]) || hasPermissions([80])) && (
                <Button shape={'circle'} className={'enterprise-settings-button'}>
                  <MoreOutlined />
                </Button>
              )}
            </Popover>
          }
        </span>
      ),
    },
  ]

  const getFilteredData = data => {
    props.handlerTextSearch(data)
  }

  const handlerEditRow = row => {    
    props.handlerEditRow(row)
  }

  const handlerDeleteRow = row => {
    props.handlerDeleteRow(row)
  }

  const handlerShowDrawer = () => {
    props.handlerShowDrawer()
  }

  return (
    <>
      <Row>
        <Col xs={18} sm={18} md={18} lg={18}>
          <Search
            prefix={<SearchOutlined className={'tendero-table-search-icon'} />}
            placeholder="Presiona enter para buscar"
            className={'tendero-table-search customSearch'}
            size={'large'}
            onSearch={e => getFilteredData(e)}
          />
        </Col>
        <Col xs={6} sm={6} md={6} lg={6} className="product-header-elements-container">
          {(
            <Button className="title-tendero new-button" style={{ width: '150px' }} onClick={handlerShowDrawer}>
              {'Nuevo nivel'}
            </Button>
          )}
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card className={'card-border-radius margin-top-15'}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Table
                  className={'CustomTableClass'}
                  dataSource={props.dataSource}
                  columns={columns}
                  pagination={false}
                  loading={props.loading}
                  rowKey="id"
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default DiscountTable
